import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

let listenerRegistered = false;

/**
 * Sets up a Universal Link listener for warm starts (app already running).
 * Cold starts are handled in main.jsx via getLaunchUrl() + history.replaceState.
 *
 * @param {function} navigate - React Router navigate function
 */
export function setupUniversalLinkHandler(navigate) {
  if (!Capacitor.isNativePlatform() || listenerRegistered) return;
  listenerRegistered = true;

  App.addListener('appUrlOpen', ({ url }) => {
    if (!url || url.includes('login-callback')) return;

    try {
      const parsed = new URL(url);

      if (parsed.hostname !== 'gettilted.app' && parsed.hostname !== 'www.gettilted.app') {
        return;
      }

      const path = parsed.pathname;
      if (path && path !== '/') {
        console.log('[UniversalLinks] warm-start navigating to:', path);
        navigate(path + parsed.search + parsed.hash);
      }
    } catch (err) {
      console.error('[UniversalLinks] failed to parse URL:', url, err);
    }
  });

  console.log('[UniversalLinks] handler registered');
}
